module.exports = __webpack_public_path__ + "img/code.9072a4af.jpg";